import { fmtNum, type BoqExtraction, type BoqLine } from '@procumi/shared';

/**
 * Antemăsurătoarea citită rămâne în memorie cât timp omul face cererile din
 * ea: pleacă la „Cerere nouă” pentru o categorie, salvează, se întoarce și
 * continuă cu următoarea. La reîncărcarea paginii se pierde, intenționat:
 * documentul nu se păstrează nicăieri.
 */

/** O poziție, așa cum o vede și o corectează omul. */
export interface BoqRow extends BoqLine {
  key: string;
  /** intră în cerere */
  on: boolean;
  /** cantitatea, ca text (se scrie cu virgulă) */
  qtyText: string;
}

export interface BoqState {
  fileName: string;
  title: string;
  warnings: string[];
  rows: BoqRow[];
  /** categoriile pentru care s-a făcut deja cererea, cu cererea făcută */
  done: Record<string, string>;
}

let state: BoqState | null = null;

export const boqState = () => state;
export const setBoqState = (s: BoqState | null) => {
  state = s;
};

/** Ce pleacă la „Cerere nouă” pentru o categorie: doar pozițiile bifate. */
export function boqDraftFor(category: string): { title: string; rows: BoqRow[] } | null {
  if (!state) return null;
  const rows = state.rows.filter((r) => r.on && r.category === category);
  if (!rows.length) return null;
  return { title: state.title ? `${category} – ${state.title}` : category, rows };
}

/** Cererea pentru categorie s-a salvat: pe pagina antemăsurătorii apare ca făcută. */
export function boqMarkDone(category: string, rfqId: string) {
  if (state) state = { ...state, done: { ...state.done, [category]: rfqId } };
}

let seq = 0;

/** Ce a citit serverul devine lista de corectat (din „Antemăsurătoare” sau de la agent). */
export function boqFromExtraction(out: BoqExtraction, fileName: string): BoqState {
  return {
    fileName,
    title: out.title,
    warnings: out.warnings,
    done: {},
    rows: out.lines.map((l) => ({
      ...l,
      key: `b${++seq}`,
      on: true,
      qtyText: l.qty == null ? '' : fmtNum(l.qty),
    })),
  };
}
